import { Wrapper, Title, Subtitle } from './styles';
import CTAButton from '../../ui/ctaButton';
import { Gapper } from '../../ui/utils';
import { openSimplePracticeConsultation } from '../../utils/simplePractice';

const StartVideoConsultation = ({ bgImg, title, subtitle, btnText, onButtonClick }) => {
  const handleStartConsultation = () => {
    if (onButtonClick) {
      onButtonClick();
      return;
    }
    openSimplePracticeConsultation();
  };

  return (
    <Wrapper bgImg={bgImg}>
      <Gapper gap={50}>
        <Gapper gap={32}>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </Gapper>
        <CTAButton text={btnText} variant="outlined" onClick={handleStartConsultation} />
      </Gapper>
    </Wrapper>
  );
};

export default StartVideoConsultation;
